import { SVGProps } from 'react';

export const DocumentsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='60'
    height='41'
    viewBox='0 0 60 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M58.5774 5.55363C58.5745 11.2981 55.9859 19.0367 50.5585 28.6494L39.1676 28.2748C39.1676 28.2748 33.5028 40.364 29.3354 39.8886L27.3189 39.2731L27.28 39.2614L3.81778 38.5527C3.81778 38.5527 -0.782112 38.5078 2.33486 27.0211C4.94229 17.411 11.6719 9.18432 11.6719 9.18432L20.3823 9.05015L26.0785 8.96244C26.0785 8.96244 29.3236 2.97778 32.5145 1.75015L48.3176 1.72196L55.2699 1.70943C55.2699 1.70943 57.8629 0.136713 58.4571 3.83239C58.5343 4.31217 58.5776 4.88096 58.5774 5.55363Z'
      fill='#EE6AAF'
    />
    <path
      d='M57.8101 2.05371C57.8204 2.06135 57.8558 2.08758 57.905 2.12402C57.8748 2.10163 57.8434 2.0784 57.8101 2.05371Z'
      fill='#7266CC'
    />
    <path
      d='M58.2531 2.66811C58.2029 2.59882 58.1607 2.52291 58.1225 2.44769C58.1149 2.43264 58.1078 2.4173 58.1005 2.40208C57.9349 2.14728 57.8068 2.05242 57.8068 2.05242C56.3884 1.00182 53.4117 3.87348 53.4117 3.87348C49.8747 6.79768 39.1675 28.2755 39.1675 28.2755L50.4654 28.808C55.8364 20.263 58.0693 11.1442 58.0693 11.1442C59.3354 6.01036 58.7518 3.64995 58.2531 2.66811Z'
      fill='#7266CC'
    />
    <path
      d='M38.3121 9.00977C38.3121 9.00977 21.8045 37.9367 28.7509 39.7111C28.7509 39.7111 25.0745 38.8472 24.3274 37.2596C23.5803 35.6721 24.9577 23.6951 25.0278 23.5317C25.0978 23.3683 33.0357 12.0917 33.0357 12.0917L36.3276 9.96714L38.3121 9.00977Z'
      fill='#32313B'
    />
    <path
      d='M58.0869 2.47571C58.0869 2.47571 53.832 -0.293989 39.1675 28.2755C39.1675 28.2755 53.4292 -4.80543 58.0869 2.47571Z'
      fill='#32313B'
    />
    <path
      d='M27.3189 39.2729L27.28 39.2611L3.81778 38.5524C3.81778 38.5524 -0.782112 38.5075 2.33486 27.0208C4.94229 17.4107 11.6719 9.18406 11.6719 9.18406L20.3823 9.04989L38.1128 9.01465C38.1128 9.01465 20.7308 35.0567 27.3189 39.2729Z'
      fill='#F4E176'
    />
    <path
      d='M39.1676 28.2517L50.4654 28.8075C62.9431 7.67854 59.2438 -3.87817 52.8935 3.59283C50.9772 5.84732 49.5259 8.52341 48.1064 11.1042C45.8082 15.2827 43.7847 19.608 41.5056 23.7962C39.3972 27.6708 37.4435 31.5832 35.1065 35.2209C33.72 37.3791 32.0204 40.1099 29.0893 39.8748C28.0179 39.7888 26.9655 39.2312 26.4003 38.317C25.9318 37.5591 25.824 36.6327 25.8315 35.7417C25.8509 33.446 26.5549 31.2128 27.3707 29.0669C30.0699 21.9665 34.042 15.4284 38.1127 9.01504C29.6744 9.01092 21.236 9.0068 12.7976 9.00268C12.4136 9.00249 12.0121 9.00635 11.6719 9.18453C11.3638 9.34588 11.1429 9.63128 10.9344 9.90972C8.12645 13.6609 5.45986 17.6201 3.87357 22.0292C-0.723847 34.8076 1.79861 37.3453 2.40037 37.897C3.15648 38.5903 4.27854 38.6554 5.304 38.6832C11.8096 38.8599 20.6391 39.0372 27.1445 39.2174'
      stroke='#32313B'
      strokeWidth='0.816327'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M54.8803 1.70996L32.4751 1.75018C32.4751 1.75018 28.6463 3.35881 26.0781 9.0089'
      stroke='#32313B'
      strokeWidth='0.816327'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M26.3714 13.609C26.5249 13.8313 26.3996 14.1819 26.09 14.3908L22.8848 16.5539C22.7268 16.6607 22.5553 16.7089 22.406 16.7006C22.257 16.6924 22.1306 16.628 22.0622 16.5095C21.926 16.2742 22.0696 15.9149 22.3815 15.7054L24.989 13.9547L23.7948 12.1464C23.6585 11.94 23.7882 11.6153 24.0833 11.4199C24.3776 11.2249 24.7293 11.2305 24.8692 11.4334L26.3714 13.609Z'
      fill='#32313B'
    />
    <path
      d='M18.6555 12.0321L16.1827 13.6478L17.0852 15.4513C17.1963 15.6733 17.0383 16.019 16.7311 16.2223C16.5773 16.3243 16.4158 16.3705 16.2794 16.3629C16.1432 16.3554 16.0322 16.2944 15.979 16.1817L14.9301 13.9708C14.8321 13.7642 14.9909 13.4433 15.2837 13.2528L18.2545 11.3204C18.5415 11.1335 18.8648 11.1386 18.9767 11.3328C19.0897 11.5285 18.9465 11.842 18.6555 12.0321Z'
      fill='#32313B'
    />
    <path
      d='M23.0441 11.443L18.5891 16.7047C18.4062 16.9206 18.1397 17.043 17.9212 17.03C17.853 17.0259 17.7899 17.0088 17.7355 16.9772C17.5063 16.8452 17.5167 16.5119 17.7557 16.2329L22.1965 11.0536C22.4137 10.8004 22.7769 10.6811 23.0107 10.7862C23.2457 10.8922 23.2616 11.1859 23.0441 11.443Z'
      fill='#32313B'
    />
    <path
      d='M21.2478 35.3125L23.2299 35.3818'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M3.38696 34.6885L20.3838 35.2829'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M14.5564 33.0166L22.9342 33.3205'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M11.7781 32.916L13.1675 32.9664'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M3.79932 32.627L10.596 32.8735'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M13.3669 30.8877L23.749 31.2588'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M10.5962 30.7891L12.4874 30.8567'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M4.33545 30.5645L9.54678 30.7507'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M9.09277 28.6582L24.5639 29.1964'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M4.61401 28.5029L6.60775 28.5723'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M19.6821 26.9365L25.3786 27.1347'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M5.42871 26.4414L18.1273 26.8832'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M11.509 24.5625L26.1932 25.0733'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M6.24341 24.3789L9.68946 24.4988'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M12.6995 22.5127L27.0079 23.0104'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M9.6897 22.4082L11.9315 22.4862'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M7.05835 22.3174L8.57037 22.37'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M25.0757 20.8535L27.8225 20.9491'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M7.87329 20.2549L23.1979 20.788'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M13.1672 18.4463L28.7788 18.9894'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M8.82959 18.2959L11.3253 18.3827'
      stroke='#32313B'
      strokeWidth='0.408163'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);
